// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Xysmn","empty":"ModalGraph_empty__a2DOi"};